import React, { useState } from 'react';
import RegistrationModal from './RegistrationModal';

const Hero = () => {
  const [showModal, setShowModal] = useState(false);

  const handleRegisterClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <section className="hero">
      <div className="hero-content container">
        <div className="hero-text">
          <h1 className="hero-headline">Practical AI for HR Leaders</h1>
          <p className="hero-subhead">Learn how to simplify, accelerate, and elevate your work with AI.</p>
          <p className="hero-description">
            Join an interactive 90-minute Build Lab designed for modern HR teams to explore real-world ways AI can enhance productivity, insights, and decision-making, without the complexity of automation or coding.
          </p>
          
          <div className="event-details">
            <div className="event-item">
              <span className="icon">📅</span>
              <span>Wednesday, 19 November 2025</span>
            </div>
            <div className="event-item">
              <span className="icon">🕑</span>
              <span>2:00 PM – 3:30 PM IST</span>
            </div>
            <div className="event-item">
              <span className="icon">📍</span>
              <span>Virtual (Zoom) | Limited seats</span>
            </div>
          </div>
          
          <button className="cta-button primary" onClick={handleRegisterClick}>
            👉 Reserve My Seat
          </button>
        </div>
        <div className="hero-visual">
          <div className="device-card">
            <img 
              src="/enculture build labs.png"
              alt="Enculture Build Labs: AI in Action – HR leaders applying AI to make work smarter, faster, and more human"
              className="hero-img"
            />
          </div>
        </div>
      </div>
      
      <RegistrationModal 
        isOpen={showModal} 
        onClose={handleCloseModal} 
      />
    </section>
  );
};

export default Hero;
